import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCircleArrowDown = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" d="M32 16c0 8.825-7.175 16-16 16S0 24.825 0 16 7.175 0 16 0s16 7.175 16 16zM2.286 16c0 7.556 6.158 13.714 13.714 13.714S29.714 23.556 29.714 16 23.556 2.286 16 2.286 2.286 8.444 2.286 16zM16 26.19l9.937-9.968-1.588-1.587-7.206 7.175V6.857h-2.286V21.81l-6.635-6.604-1.587 1.588z" /></g></svg>;
export default SvgCircleArrowDown;